import React from 'react';
import classNames from 'classnames';
import { fireTag } from '../../../libs/analytics';
import { GAfireEvent } from '../../Tracking';

// console.log('CHECK STATE OF HOVER', hover[id], count);
const TypeDesktopItem = ({ id, name, color, func, alt_name, filteredOrgs, selectedItem, desktopSelectedCat }) => {

    let len = 0, btnID;
    let thisCatOrgs = [];

    if (typeof filteredOrgs != 'undefined') {

        thisCatOrgs = filteredOrgs
            .filter(org => parseInt(org.properties.category_id, 10) === id);

        len = thisCatOrgs.length;

    }

    function convertCatNameToStylename(catName) {
      // remove all non-alphabetic chars
      let newCatStyleName = catName.replace(/[^A-Za-z/ ]/g, "").toLowerCase();
      // replace all spaces with hyphens
      newCatStyleName = `${newCatStyleName.replace(/ /g, "-")  }-btn`;
      return newCatStyleName;
    }


    return (
		// eslint-disable-next-line react/button-has-type
        <button id={(convertCatNameToStylename(alt_name))}
          role="option"
          tabIndex="0"
          className={color}
          onClick={() => {
            fireTag('C4',name.toLowerCase());
            //GAfireEvent((alt_name !== desktopSelectedCat ? 'C60' : 'C61'), {category: false, action: false, label: name});
            func(alt_name);
          }}
        >
          <div className={`swatch ${color}`}>
            {alt_name === selectedItem && (
            <span className="list-item-checkmark">
              <div className="icon-checkmark"/>
            </span>
            )}
          </div>
          <div
            className={classNames('community', alt_name === selectedItem ? 'selected' : '')}
          >{name}</div>
          <div className="count">{len} Orgs.</div>
          <div className="btn-on">
            <div className="community-selected">{name}</div>
          </div>
        </button>
    );
};

export default TypeDesktopItem;
